import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

const selectSubCompanyCompanyProfileState = createSelector(
  selectSubCompany,
  subCompany => subCompany?.companyProfile || {},
);

export const selectSubCompanyCompanyProfile = createSelector(
  selectSubCompanyCompanyProfileState,
  state => state.profile || null,
);
